import { IBreadcrumbSchema } from '../../../node/repositories/countryside-search/entities/breadcrumbs/BreadcrumbSchema';
import { IGeoAddressSchema } from '../../repositories/countryside-search/entities/geo/GeoAddressSchema';
import { IVillageForListPresenterSchema } from '../../repositories/countryside-search/entities/village/VillageForListPresenterSchema';
import { getUserDataForTracking } from './getUserDataForTracking';
import { gatherAnalyticsInfo } from './gatherAnalyticsInfo';
import { getCriteo } from './getCriteo';
import { getLocationIds } from './getLocationIds';
import { getFBGeo } from './getFBGeo';
import { isArrayWithItems } from '..';
import { getVillageList } from './getVillageList';
import { ISopr1Params, EListingType, EPageType, EDealType, EObjectType, ESortType } from '../../types/analytics';
import { getSiteType } from './getSiteType';
import { IApplicationState } from '../../types/store';

export const generateTrackingPageViewObject = (
  state: IApplicationState,
  village?: IVillageForListPresenterSchema,
): ISopr1Params => {
  const {
    filters,
    mobile: { deviceType, isMobileVersion },
    userData: { user, userGaData },
    abGroup,
  } = state;

  const villageList = getVillageList(state.villageList, filters.p || 1, isMobileVersion);
  const totalItems = state.villageList.totalItems;
  const geo = village ? village.geo : (isArrayWithItems(villageList) && villageList[0].geo) || null;
  const fbGeo = geo ? getFBGeo(geo.address as IGeoAddressSchema) : [];

  return {
    page: {
      pageType: EPageType.ListingKP,
      siteType: getSiteType(deviceType),
      breadCrumbs: (state.villageList.breadcrumbs as IBreadcrumbSchema[]).map(breadcrumb => breadcrumb.title),
      dealType: EDealType.sale,
      objectType: EObjectType.kp,
      region: getLocationIds(geo).join('-'),
      listingType: EListingType.list,
      sortType: ESortType.default,
      pageNumber: filters.p || 1,
      offersQty: totalItems as number,
      offerType: 'KP',
    },
    partner: {
      ...getCriteo(userGaData),
      FB_city: (fbGeo[2] || fbGeo[0]) as string | undefined,
      FB_region: fbGeo[0] as string | undefined,
    },
    products: village
      ? [
          gatherAnalyticsInfo(
            village,
            villageList.findIndex(({ id }) => id === village.id),
          ),
        ]
      : villageList.map(gatherAnalyticsInfo),
    sc: filters,
    user: getUserDataForTracking({ userData: user, userGaData, abGroup }),
  };
};
